<template>
  <div style="background: url('../../static/img/login-bg.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;"
  class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group class="login-modal-card-group" no-border>
            <b-card @keyup.enter="submit" no-body class="p-4 login-modal-card">
              <b-card-body>
                <div class="login-modal-title-wrapper marginTop0 marginB12">
                  <h2 class="login-modal-title login-modal-title--bold">Reset Your Password</h2>
                </div>
                <p class="login-modal-text marginB8">
                  Your password needs to meet the following requirements:
                </p>
                <ul class='marginB12'>
                  <li :class="{'login-modal-text': true, 'login-modal-text--xs': true, 'passedColor': this.lengthPassed === true, 'failedColor': this.lengthPassed === false}">
                    <span>
                      MUST contain at least 8 characters
                    </span>
                  </li>
                  <li :class="{'login-modal-text': true, 'login-modal-text--xs': true, 'passedColor': this.regexPassed === true, 'failedColor': this.regexPassed === false}">
                    <span>
                      MUST contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (!@#$%^&*?,._)
                    </span>
                  </li>
                  <li :class="{'login-modal-text': true, 'login-modal-text--xs': true, 'passedColor': this.consecutiveRepeatPassed === true, 'failedColor': this.consecutiveRepeatPassed === false}">
                    <span>
                      MAY NOT contain repeating or consecutive characters
                    </span>
                  </li>
                  <li :class="{'login-modal-text': true, 'login-modal-text--xs': true, 'passedColor': this.containEmailPassed === true, 'failedColor': this.containEmailPassed === false}">
                    <span>
                      MAY NOT contain part of your name or email
                    </span>
                  </li>
                </ul>
                <b-input-group class="login-modal-form-input">
                  <!-- <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icon-lock"></i>
                    </span>
                  </div> -->

                  <input
                    type="password"
                    @keyup.enter="resetPassword"
                    required=""
                    id="password"
                    name="password"
                    v-model="password"
                    placeholder="Password"
                    data-vv-delay="500"
                    class="form-control"
                    ref="password"
                    :class="{'input-box': true, 'is-danger': inputValidationErrors.has('password') }"
                  >
                  <!-- v-validate="'required|min:8|max:255|verify_password'" -->
                  </b-input-group>
                  <p v-show="inputValidationErrors.has('password')" class="alert-text help is-danger-msg">
                    {{ inputValidationErrors.first('password') }}
                  </p>


                <b-input-group class="login-modal-form-input">
                  <!-- <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div> -->
                  <input
                    type="password"
                    @keyup.enter="resetPassword"
                    required=""
                    id="confirmpassword"
                    name="confirmpassword"
                    v-model="confirmpassword"
                    placeholder="Confirm Password"
                    data-vv-delay="500"
                    data-vv-as="password"
                    class="form-control marginB24"
                    :class="{'input-box': true, 'is-danger': inputValidationErrors.has('confirmpassword') }"
                  >
                  <!-- v-validate="'required:password||confirmed:password'" -->
                  </b-input-group>
                  <p v-show="confirmPasswordError" class="login-modal-text login-modal-text--xs failedColor">
                    Passwords do not match.
                  </p>
                  <!-- <p v-show="inputValidationErrors.has('confirmpassword')" class="alert-text help is-danger-msg">
                    {{ inputValidationErrors.first('confirmpassword') }}
                  </p> -->

                <div class='login-modal-footer marginTop0 login-modal-footer--widePadding'>
                  <b-button
                    variant="primary"
                    @click="resetPassword"
                    class="button-regular button-regular--send px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width margin0"
                    type="submit"
                  >
                  Send
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'resetPassword',
  computed: mapGetters({
    resetPasswordSuccess: 'getResetPasswordSuccess',
    userEmail: 'getUserEmailByPasswordResetToken'
  }),
  data () {
    return {
      dictionary: {
        custom: {
          password: {
            required: () => 'Please enter the Password field.'
          },
          confirmpassword: {
            required: () => 'Please enter the Confirm Password field.'
          }
        }
      },
      title: 'Welcome to Allies - Please Enter Your New Password to Reset',
      password: '',
      confirmpassword: '',
      confirmPasswordError: false,
      lengthPassed: null,
      regexPassed: null,
      consecutiveRepeatPassed: null,
      containEmailPassed: null
      }
  },
  watch: {
    // whenever question changes, this function will run
    resetPasswordSuccess: function (newValue, oldValue) {
      if (newValue) {
        this.$router.push({ path: `/login` })
      }
    },
    password (value) {
      // minimum of 8 characters
      if (value.length > 7) {
        this.lengthPassed = true
      } else {
        this.lengthPassed = false
      }

      // requirements of at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 symbol
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?.,_])') // (?=.{8,})
        if (!strongRegex.test(value)) {
          this.regexPassed = false
          // return false
        } else {
          this.regexPassed = true
        }

        // prevent use of consecutive characters
        if (this.hasSequentialChars(value) || this.hasSequentialNums(value)) {
          this.consecutiveRepeatPassed = false
          // return false
        } else {
          this.consecutiveRepeatPassed = true
        }

        // prevent use of consecutively repeated characters
        if (new RegExp(/(.)\1/).test(value)) {
          this.consecutiveRepeatPassed = false
          // return false
        } else {
          this.consecutiveRepeatPassed = true
        }

        // prevent use of passwords containing parts of username / email
        if (this.userEmail) {
          const indexOfAt = this.userEmail.indexOf('@')
          if (indexOfAt > -1) {
            const emailPart1 = this.userEmail.slice(0, indexOfAt)
            // const emailPart2 = this.userEmail.slice(indexOfAt + 1, this.userEmail.length)
            const limit1 = Math.min(emailPart1.length, 4)
            // const limit2 = Math.min(emailPart2.length, 4)
            if (value.toLowerCase().includes(this.userEmail.toLowerCase().substring(0, limit1)) ||
            value.toLowerCase().includes(this.userEmail.toLowerCase().substring(indexOfAt + 1))) {
              this.containEmailPassed = false
            } else {
              this.containEmailPassed = true
            }
          }
        }

        if (value.length === 0) {
          this.lengthPassed = null
          this.regexPassed = null
          this.consecutiveRepeatPassed = null
          this.containEmailPassed = null
        }
    },
    confirmpassword (newValue) {
      if (newValue.length === 0) {
        this.confirmPasswordError = false
      }
    }
  },
  methods: {
    // verifyPassword (value) {
    //   // getMessage: () => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (!@#$%^&*?,._), and must not contain repeating or consecutive characters and/or use part of your name or email.`,
    //   // validate: (value) => {
    //     // minimum of 8 characters, keeping the same requirements of at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 symbol
    //     var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?.,_])(?=.{8,})')
    //     if (!strongRegex.test(value)) {
    //       return false
    //     }

    //     // prevent use of consecutive characters
    //     if (this.hasSequentialChars(value) || this.hasSequentialNums(value)) {
    //       return false
    //     }

    //     // prevent use of consecutively repeated characters
    //     if (new RegExp(/(.)\1/).test(value)) {
    //       return false
    //     }

    //     // prevent use of passwords containing parts of username / email
    //     if (!this.userEmail) {
    //       return false
    //     }

    //     const indexOfAt = this.userEmail.indexOf('@')
    //     if (indexOfAt <= -1) {
    //       return false // not a valid email
    //     }

    //     const userName = this.userEmail.slice(0, indexOfAt)
    //     const limit = Math.min(userName.length, 4)

    //     // part of user name more than 4 characters or the length of user name
    //     return !value.toLowerCase().includes(userName.toLowerCase().substring(0, limit))
    //   // }
    // },
    resetPassword: function () {
      // this.$validator.validate().then(result => {
      //   if (result) {
        if (this.password !== this.confirmpassword) {
          this.confirmPasswordError = true
          return false
        }
        if (this.lengthPassed === true && this.regexPassed === true && this.consecutiveRepeatPassed === true && this.containEmailPassed === true) {
          var token = this.$route.params.passwordResetToken
          if (token && this.password) {
            this.$store.dispatch('resetPassword', { passwordResetToken: token, password: this.password })
          }
        }
        // }
      // })
    },
    hasSequentialNums (s) {
      // ascending
      for (let i = 0; i < s.length - 1; i++) {
        if ((+s.charAt(i + 1) === +s.charAt(i) + 1)) {
          return true
        }
      }
    },
    hasSequentialChars (s) {
      // ascending
      const lowerCase = s.toLowerCase()
      for (let i = 0; i < lowerCase.length - 1; i++) {
        if (String.fromCharCode(lowerCase.charCodeAt(i) + 1) === lowerCase.charAt(i + 1)) {
          return true
        }
      }
    }
  },
  created () {
    this.$store.dispatch('getUserEmailByPasswordResetToken', {
      passwordResetToken: this.$route.params.passwordResetToken
    })
    this.$validator.localize('en', this.dictionary)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.button-regular {
  width: 118px;
}
.alert-error > label.input-label, .is-danger-msg {
  color: #B64242;
}
</style>


// WEBPACK FOOTER //
// src/views/pages/ResetPassword.vue